<script>
import axios from 'axios'

export default {
  data() {
    return {
      state: 'unsubmitted',
      message: {
        email: '',
        currentSite: this.site
      },
      errors: {},
      endpoint: '/api/newsletter'
    }
  },
  mounted() {
  },
  props: ['csrfToken', 'csrfTokenName', 'site'],
  computed: {
    unsubmitted() {
      return this.state == 'unsubmitted'
    },
    sending() {
      return this.state == 'sending'
    },
    sent() {
      return this.state == 'sent'
    },
    emailValid() {
      return this.message.email.length > 0
    },
    submitButtonDisabled() {
      return (!this.emailValid || this.sending) ? true : false
    },
    api() {
      return axios.create()
    },
  },
  methods: {
    submit() {
      this.state = 'sending'

      this.$set(this.message, this.csrfTokenName, this.csrfToken);
      console.log(this.message);
      this.api.post(this.endpoint, this.message)
          .then((response) => {
            if (response.data.statusCode === 200)
            {
              this.state = 'sent'
              this.errors = {};
              this.$set(this.message, 'email', '');
            }
            else
            {
              this.errors = response.data.body.error
              this.state = 'unsubmitted'
            }
          }, (error) => {})
    },
    hasError(field) {
      let data = false
      for (let key of Object.keys(this.errors))
      {
        if (field == key)
        {
          data = true
          break
        }
      }
      return data
    },
    unsetForm() {
      this.state = 'unsubmitted'
    }
  }
}
</script>
